import { render, staticRenderFns } from "./PageViewsChart.vue?vue&type=template&id=4f9bbef4&"
import script from "./PageViewsChart.vue?vue&type=script&lang=js&"
export * from "./PageViewsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports